import { formatMoney, type OrderDto } from '@restaurant/shared';
import { esc, printHtml } from './printHtml';

/** Kitchen ticket sized for 80mm thermal printers, printed from a hidden iframe. */
export function printTicket(o: OrderDto, restaurant: string, currency: string): void {
  const lines = o.items
    .map((i) => `<tr><td>${i.quantity}×</td><td>${esc(i.name)}${i.options.length ? `<br><small>${esc(i.options.map((x) => x.name).join(', '))}</small>` : ''}${i.notes ? `<br><small><i>${esc(i.notes)}</i></small>` : ''}</td><td class="r">${formatMoney(i.lineTotalCents, currency)}</td></tr>`)
    .join('');
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>#${o.number}</title><style>
    body{font:13px/1.35 ui-monospace,Menlo,monospace;width:72mm;margin:0 auto;padding:4mm}
    h1{font-size:22px;margin:0 0 2px;text-align:center} p{margin:2px 0} table{width:100%;border-collapse:collapse;margin:6px 0}
    td{vertical-align:top;padding:2px 0} .r{text-align:right;white-space:nowrap} hr{border:0;border-top:1px dashed #000} .c{text-align:center}
  </style></head><body>
    <p class="c">${esc(restaurant)}</p><h1>#${o.number}</h1>
    <p class="c"><b>${o.type === 'delivery' ? 'DELIVERY' : 'PICKUP'}</b> · ${new Date(o.createdAt).toLocaleString()}</p><hr>
    <table>${lines}</table><hr>
    ${o.deliveryFeeCents ? `<p>Delivery: ${formatMoney(o.deliveryFeeCents, currency)}</p>` : ''}
    <p><b>TOTAL ${formatMoney(o.totalCents, currency)}</b> (${o.paymentMethod === 'cash' ? 'cash' : 'card'})</p>
    <p>${esc(o.customer.name ?? '')} +${o.customer.waId}</p>
    ${o.address ? `<p>${esc(o.address)}</p>` : ''}${o.notes ? `<p><i>${esc(o.notes)}</i></p>` : ''}
  </body></html>`;
  printHtml(html);
}
